import { apiFuns } from "sw-hic";
let { get, put, del, post, genStandard, exceptedReqs } = apiFuns;

console.log(exceptedReqs);
const api = {
  /*********** 住院记录 ***********/
  Hospitalization: {
    ...genStandard("hospitalization", "/api/ip", false),
  },

  /*********** 记账记录 ***********/
  VitalSigns: genStandard("vitalSigns", "/api/ip"),
};

export default api;
